<script>
import { cadastroServico, adicionarTransacao, pagarme } from '@constants/URL'
import con from '@services/connection'
import { mask } from 'vue-the-mask'
import CardDiv from '@components/card-div'
import Title from '@components/section-title'
import { VMoney } from 'v-money'
import cep from '@services/cep'
import store from '@state/store'
import { MODAL, RELOAD } from '@constants/Text'
import { GlobalBus } from '@services/bus'
import rules from '@constants/Rules'
import {
  getNumber,
  checkEmail,
  validarData,
  dataWirecard,
  removeAccents,
  toMoney,
} from '@utils/Format'
import { getAreaCode, getPhoneNumber } from '@utils/Find'
import Vue from 'vue'

export default {
  directives: {
    mask,
    money: VMoney,
  },
  components: {
    Title,
    CardDiv,
  },
  props: {
    textButton: {
      type: String,
      default: 'Novo servico',
    },
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busModal: new Vue(),
      maskNumber: '##########',
      maskNumberShort: '##',
      maskPhone: '(##) #####-####', // TODO: Considerar 8 digitos
      maskCPF: '###.###.###-##', // TODO: Considerar CNPJ junto
      maskCNPJ: '##.###.###/####-##',
      maskData: '##/##/####',
      maskCEP: '#####-###', // TODO: Verificar formatos de cep
      bank_account: '##########-#',
      step: 1,
      toMoney: toMoney,
      validDadosBasicos: false,
      validTaxa: false,
      validDadosPessoais: false,
      validDadosEmpresariais: false,
      validDadosBancarios: false,
      its_free: false,
      concluido: false,
      rules: {
        ...rules,
        taxMinReal: (v) => getNumber(v) >= 2.99 || 'Valor mínimo: R$ 2,99',
        taxMinPerc: (v) => getNumber(v) >= 0.01 || 'Valor mínimo: 0,01 %',
        positive: (v) => getNumber(v) >= 1 || 'Maior que 0',
        required: (v) => !!v || 'Campo obrigatório',
        email: (v) => checkEmail(v) || 'Formato inválido',
        data: (v) => !!validarData(v) || 'Formato inválido',
        cep: (v) => v.length === 9 || 'Formato inválido',
        metodoBruto: (v) =>
          !(v === 'Recorrente' && this.taxaPatrimonio) ||
          'Não é possível cobrar uma taxa sobre o patrimônio e um valor recorrente simultaneamente.',
        max12: (v) => v <= 12 || 'No máximo em 12x',
        min1: (v) => v >= 1 || 'No mínimo 1x',
        maxSize: (v) =>
          !!(!v || v.size < 5200000) ||
          'Arquivo maior que o tamanho limite (10 MB)',
      },
      maskMoney: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      maskPercent: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' %',
        precision: 2,
        masked: false,
      },
      servico: {
        nome: '',
        descricao: '',
        taxaBruta: 2.99,
        tipo_servico: 'Serviço',
        taxaPatrimonio: '0,10',
        valorMinimo: 2.99,
        metodoBruto: 'À vista',
        qtdParcelas: 1,
        blackListInstituicoes: [],
        visivel: false,
        visivel_para_profissionais: true,
      },
      dados_pessoais: {
        firstname: '',
        lastname: '',
        email: '',
        telefone: '',
        cpf: '',
        data_nascimento: '',
        cep: '',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
      },
      dados_empresariais: {
        nome_fantasia: '',
        razao_social: '',
        cnpj: '',
        telefone: '',
        rua: '',
        numero: '',
        bairro: '',
        cep: '',
        complemento: '',
        cidade: '',
        estado: '',
      },
      dados_bancarios: {
        codigo: '',
        agencia: '',
        conta: '',
        documento: '',
        nome: '',
      },
      outro_nome: '',
      outro_codigo: '',
      modelos: [
        {
          title: 'Free',
          subtitle: 'Conecte-se e acompanhe a posição do seu cliente',
          actions: {
            servico: {
              taxaBruta: 2.99,
              taxaPatrimonio: '0,10',
              valorMinimo: 2.99,
              tipo_servico: 'Serviço Free',
              metodoBruto: 'À vista',
              qtdParcelas: 1,
              blackListInstituicoes: [],
              visivel_para_profissionais: true,
            },
            its_free: true,
            taxaBruta: false,
            taxaPatrimonio: false,
          },
        },
        {
          title: 'Taxa anual',
          subtitle: 'Modelo fee-only',
          actions: {
            servico: {
              taxaBruta: 0,
              taxaPatrimonio: '0,10',
              tipo_servico: 'Serviço Anual',
              valorMinimo: 2.99,
              metodoBruto: 'Recorrente',
              qtdParcelas: 1,
              blackListInstituicoes: [],
              visivel_para_profissionais: true,
            },
            taxaPatrimonio: true,
          },
        },
        {
          title: 'Valor mensal',
          subtitle: 'Cobrança de R$ XX todo mês',
          actions: {
            servico: {
              taxaBruta: 2.99,
              taxaPatrimonio: '0,10',
              tipo_servico: 'Serviço Mensal',
              valorMinimo: 2.99,
              metodoBruto: 'Recorrente',
              qtdParcelas: 1,
              blackListInstituicoes: [],
              visivel_para_profissionais: true,
            },
            taxaBruta: true,
          },
        },
        {
          title: 'Planejamento',
          subtitle: 'Cobrança de R$ XX 1x',
          actions: {
            servico: {
              taxaBruta: 2.99,
              taxaPatrimonio: '0,10',
              tipo_servico: 'Planejamento',
              valorMinimo: 2.99,
              metodoBruto: 'À vista',
              qtdParcelas: 1,
              blackListInstituicoes: [],
              visivel_para_profissionais: true,
            },
            taxaBruta: true,
          },
        },
        {
          title: 'Cursos',
          subtitle: 'Crie seu modelo',
          actions: {
            servico: {
              taxaBruta: 2.99,
              taxaPatrimonio: '0,10',
              tipo_servico: 'Curso',
              valorMinimo: 2.99,
              metodoBruto: 'Recorrente',
              qtdParcelas: 1,
              blackListInstituicoes: [],
              visivel_para_profissionais: true,
            },
            taxaBruta: true,
          },
        },
        {
          title: 'Relatórios',
          subtitle: 'Crie o seu modelo',
          actions: {
            servico: {
              taxaBruta: 2.99,
              taxaPatrimonio: '0,10',
              tipo_servico: 'Relatório',
              valorMinimo: 2.99,
              metodoBruto: 'Recorrente',
              qtdParcelas: 1,
              blackListInstituicoes: [],
              visivel_para_profissionais: true,
            },
            taxaBruta: true,
          },
        },
        {
          title: 'Outros',
          subtitle: 'Crie o seu modelo personalizado',
          actions: {
            servico: {
              taxaBruta: 2.99,
              taxaPatrimonio: '0,10',
              tipo_servico: 'Outro',
              valorMinimo: 2.99,
              metodoBruto: 'Recorrente',
              qtdParcelas: 1,
              blackListInstituicoes: [],
              visivel_para_profissionais: true,
            },
          },
        },
      ],
      taxaPatrimonio: null,
      taxaBruta: null,
      pj: null,
      tem_conta_wirecard: false,
      datePicker1: null,
      dataNascimento: '',
      edit: {
        dataNascimento: '',
      },
      aceptTerms: false,
      loading: false,
      fileImagem: null,
      fileAnexo: null,
      urlImagem: '',
      loadingDadosPessoais: false,
      loadingCheck: false,
      novoServico: {},
      bancos: [],
      cancelProcess: false,
      cadastrarConta: false,
      messageReceivingAccount: '',
      indicar_servico: false,
      pct_repasse: 0,
    }
  },
  computed: {
    isWhitelabel() {
      return this.$isWhitelabel()
    },
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    has_wirecard_account() {
      return this.tem_conta_wirecard || this.its_free
    },
    opcoesParcelas() {
      const valor = getNumber(this.servico.taxaBruta || 0)
      let parcelas = []
      for (let i = 1; i <= 12; i++) {
        parcelas.push({
          text: `${i}x de ${toMoney(valor / i)}`,
          value: i,
        })
      }
      return parcelas
    },
    valorParcelas() {
      return toMoney(
        getNumber(this.servico.taxaBruta || 0) / (this.servico.qtdParcelas || 1)
      )
    },
  },
  created() {
    this.bus.$on(MODAL.CADASTRAR_SERVICOS, this.open)
  },
  beforeDestroy() {
    this.bus.$off(MODAL.CADASTRAR_SERVICOS, this.open)
  },
  methods: {
    async open(v) {
      if (!this.usuarioAtual.IS_GESTOR && this.isWhitelabel) {
        this.$showModal({
          text: 'Você não tem permissão para cadastrar serviços, caso deseje cadastrar um novo serviço peça para o seu gestor.',
          title: 'Cadastrar serviços',
          buttons: [
            {
              text: 'Voltar',
              class: { primary: true },
            },
          ],
        })
        return
      }
      this.resetData()
      this.loadingCheck = true
      this.busModal.$emit('dialog', v)
      // const r = await con.post(cadastroServico.check_wirecard)
      const r = await con.get(pagarme.check_receiver)
      this.tem_conta_wirecard = r.status === 200
      this.cancelProcess = r.status === 401
      this.cadastrarConta = r.status === 404
      this.messageReceivingAccount = r.message
      this.loadingCheck = false

      if (this.cadastrarConta) {
        this.loadBanks()
      }
    },
    async salvar(close) {
      if (this.loading) {
        return
      }
      let r_dados
      if (!this.its_free) {
        const validService = this.$refs.formDadosBasicos.validate()
        if (!this.has_wirecard_account) {
          this.$refs.formDadosPessoais.validate()
          if (this.pj) {
            this.$refs.formDadosEmpresariais.validate()
          }
        }
        let valido =
          ((this.validDadosPessoais &&
            (!this.pj || this.validDadosEmpresariais)) ||
            this.has_wirecard_account) &&
          this.aceptTerms &&
          this.validDadosBasicos

        if ((!valido && !this.its_free) || (this.its_free && !validService)) {
          return false
        }

        this.loading = true
        if (!this.has_wirecard_account) {
          r_dados = await this.salvarDadosPessoais()
          if (r_dados.status !== 200) {
            this.$showSnack({
              text: r_dados.message,
              button: true,
            })
          }
        }
      }

      if (
        this.its_free ||
        (r_dados && r_dados.status === 200) ||
        this.has_wirecard_account
      ) {
        this.loading = true
        const taxa_rec =
          this.taxaBruta && this.servico.metodoBruto === 'Recorrente'
            ? this.servico.taxaBruta
            : this.taxaPatrimonio
            ? this.servico.taxaPatrimonio
            : 0
        const tipo_taxa_rec =
          this.taxaBruta && this.servico.metodoBruto === 'Recorrente'
            ? 'bruto'
            : 'percentual'
        const data = {
          nome_servico: this.servico.nome,
          descricao_servico: this.servico.descricao,
          tipo_servico: this.servico.tipo_servico || 'Serviço', // TODO: mudar para tipo que ele selecionou no começo
          taxa: getNumber(
            this.taxaBruta && this.servico.metodoBruto !== 'Recorrente'
              ? this.servico.taxaBruta
              : 0
          ),
          tipo_taxa: 'bruto',
          numero_parcelas:
            this.taxaBruta && this.servico.metodoBruto === 'Parcelado'
              ? this.servico.qtdParcelas
              : 1,
          taxa_recorrente: this._getTaxValue(taxa_rec, tipo_taxa_rec),
          tipo_taxa_recorrente: tipo_taxa_rec,
          valor_minimo_recorrencia: getNumber(this.servico.valorMinimo || 2.99),
          free: this.its_free,
          visivel: !!this.servico.visivel,
          visivel_para_profissionais: !!this.servico.visivel_para_profissionais,
          imagem: this.fileImagem,
          anexo: this.fileAnexo,
          permite_indicacao: this.indicar_servico,
          taxa_rebate_indicacao: this._getTaxValue(
            this.pct_repasse,
            'percentual'
          ),
        }
        if (this.$refs.formConfig.validate()) {
          const r = await con.post(cadastroServico.add_service, data) // dev.espelho
          if (r.status === 200) {
            // close()
            this.step = this.has_wirecard_account ? 6 : 7
            this.concluido = true
            GlobalBus.$emit(RELOAD.SERVICES, true)
            this.novoServico = r.value
          } else {
            this.$showSnack({
              text: r.message,
              button: true,
            })
          }
        }
      }
      this.loading = false
    },
    async salvarDadosPessoais() {
      let data = {
        email: this.dados_pessoais.email,
        number_doc: this.dados_pessoais.cpf,
        name: this.dados_pessoais.firstname,
        lastname: this.dados_pessoais.lastname,
        tipo_doc: 'CPF',
        data_nascimento: dataWirecard(this.dados_pessoais.data_nascimento), // Padrao wirecard
        countryCode: '55',
        areaCode: getAreaCode(this.dados_pessoais.telefone),
        telefone: getPhoneNumber(this.dados_pessoais.telefone),
        rua: this.dados_pessoais.rua,
        numero_rua: this.dados_pessoais.numero,
        complemento: this.dados_pessoais.complemento,
        bairro: this.dados_pessoais.bairro,
        cep: this.dados_pessoais.cep,
        cidade: this.dados_pessoais.cidade,
        estado: this.dados_pessoais.estado,
        pais: 'BRA',
      }
      if (this.pj) {
        data = {
          ...data,
          empresa_nome_fantasia: this.dados_empresariais.nome_fantasia,
          empresa_razao_social: this.dados_empresariais.razao_social,
          empresa_tipo_doc: 'CNPJ',
          empresa_numero_doc: this.dados_empresariais.cnpj,
          empresa_codigo_area: getAreaCode(this.dados_empresariais.telefone),
          empresa_telefone_numero: getPhoneNumber(
            this.dados_empresariais.telefone
          ),
          empresa_rua: this.dados_empresariais.rua,
          empresa_numero: this.dados_empresariais.numero,
          empresa_endereco_complemento: this.dados_empresariais.complemento,
          empresa_bairro: this.dados_empresariais.bairro,
          empresa_cep: this.dados_empresariais.cep,
          empresa_cidade: this.dados_empresariais.cidade,
          empresa_estado: this.dados_empresariais.estado,
          empresa_pais: 'BRA',
        }
      }

      const bank_account = this.collectBankAccount()
      const r = await con.post(pagarme.add_bank_account, bank_account)
      if (r.status !== 200) {
        return new Promise((resolve) => {
          resolve(r)
        })
      }

      // return con.post(cadastroServico.add_wirecard, data) // dev.espelho
      return con.post(pagarme.add_receiver, data)
    },
    resetData() {
      this.step = 1
      this.servico = {
        nome: '',
        descricao: '',
        taxa: 2.99,
        tipo_servico: 'Serviço',
        tipoTaxa: 'Real',
        taxaRecorrente: 2.99,
        tipoTaxaRecorrente: 'Real',
        valorMinimoRecorrente: 2.99,
        metodoPagamento: 'À vista',
        qtdParcelas: 1,
        visivel: false,
        visivel_para_profissionais: true,
      }
      this.taxaPatrimonio = null
      this.taxaBruta = null
      this.concluido = false
      this.fileImagem = null
      this.fileAnexo = null
      this.urlImagem = ''
      this.tem_conta_wirecard = false
      this.aceptTerms = false
      this.its_free = false
      this.concluido = false
      this.loading = false
      if (this.$refs.formDadosBasicos) {
        this.$refs.formDadosBasicos.resetValidation()
      }
      !this.$refs.formTaxa || this.$refs.formTaxa.resetValidation()
      !this.$refs.formDadosPessoais ||
        this.$refs.formDadosPessoais.resetValidation()
      !this.$refs.formDadosEmpresariais ||
        this.$refs.formDadosEmpresariais.resetValidation()
    },
    openSendLink(close) {
      this.bus.$emit(MODAL.SEND_LINK, {
        id_servico: this.novoServico.id_servico,
        nome_servico: this.servico.nome,
      })
      close()
    },
    toServices() {
      if (this.$route.name.includes('servicos')) {
        this.busModal.$emit('dialog', false)
      } else {
        this.$router.push({ name: 'servicos' })
      }
    },
    async changeUploadImage(file) {
      if (file) {
        let reader = new FileReader()
        reader.onload = () => {
          this.urlImagem = reader.result
        }
        reader.readAsDataURL(file)
      } else {
        this.urlImagem = ''
      }
      // const r = await con.post(dev.espelho, { imagem: this.fileImagem })
      // this.urlImagem = 'https://picsum.photos/510/300?random'
    },
    doActions(actions) {
      if (actions.servico) {
        this.servico = {
          ...this.servico,
          ...actions.servico,
        }
      }
      this.taxaPatrimonio = !!actions.taxaPatrimonio
      this.taxaBruta = !!actions.taxaBruta
      this.its_free = !!actions.its_free
      if (this.cancelProcess && !actions.its_free) {
        this.$showSnack({
          text: this.messageReceivingAccount,
          button: true,
        })
        return
      }
      this.step = 2
    },
    async getCepDadosPessoais() {
      const r = await cep(this.dados_pessoais.cep)
      if (r.status === 200) {
        // r
        this.dados_pessoais = {
          ...this.dados_pessoais,
          // rua: r.street,
          // bairro: r.neighborhood,
          // cidade: r.city,
          // estado: r.state,
          rua: r.value.logradouro,
          bairro: r.value.bairro,
          cidade: r.value.localidade,
          estado: r.value.uf,
        }
      }
    },
    async getCepDadosEmpresariais() {
      const r = await cep(this.dados_empresariais.cep)
      if (r.status === 200) {
        // r
        this.dados_empresariais = {
          ...this.dados_empresariais,
          rua: r.value.logradouro,
          bairro: r.value.bairro,
          cidade: r.value.localidade,
          estado: r.value.uf,
        }
      }
    },
    statusNextButton() {
      const step = Number(this.step)
      if (step === 2) {
        return this.$refs.formDadosBasicos.validate()
      }
      if (step === 3) {
        return this.$refs.formTaxa.validate()
      }
      if (step === 4 && !this.has_wirecard_account) {
        return (
          this.$refs.formDadosPessoais.validate() &&
          (!this.pj || this.$refs.formDadosEmpresariais.validate())
        )
      }
      if (step === 4 && this.has_wirecard_account) {
        return true
      }
      if (step === 5 && !this.has_wirecard_account) {
        return true
      }
      return false
    },
    nextStep() {
      if (this.statusNextButton()) {
        if (this.step === 2 && this.its_free) {
          this.step = Number(this.step) + 2
          return
        }
        this.step = Number(this.step) + 1
      }
    },
    backStep() {
      if (this.step > 4 && this.its_free) {
        this.step = Number(this.step) - 3
        return
      }
      if (this.step > 3 && this.its_free) {
        this.step = Number(this.step) - 2
        return
      }
      this.step = Number(this.step) - 1
    },
    _getTaxValue(valor, botao) {
      if (botao === 'bruto') {
        return getNumber(valor)
      }
      if (botao === 'percentual') {
        return getNumber(valor) / 100
      }
    },
    async loadBanks() {
      const data = {
        somente_disponiveis: 0,
      }
      let r = await con.get(adicionarTransacao.bancos.listar, data)

      if (typeof r === 'string') {
        r = JSON.parse(r.split('NaN').join('0'))
      }

      if (r.status === 200) {
        this.bancos = r.value.sort((a, b) => {
          return a.nome > b.nome ? 1 : -1
        })
      } else {
        this.bancos = []
      }
    },
    collectBankAccount() {
      if (this.$refs.formDadosBancarios) {
        if (this.$refs.formDadosBancarios.validate()) {
          const banco = this.bancos.find((b) => {
            return b.codigo === this.dados_bancarios.codigo
          })

          const ehOutros = this.dados_bancarios.codigo === -1

          const data = {
            banco: ehOutros
              ? `${this.outro_codigo} - ${this.outro_nome}`
              : `${banco.codigo || ''} - ${banco.nome}`, // cod + nome
            cod_banco: ehOutros
              ? this.outro_codigo
              : this.dados_bancarios.codigo,
            nome_banco: ehOutros ? this.outro_nome : banco.nome,
            agencia: this.dados_bancarios.agencia.split('-')[0] || null,
            conta: this.dados_bancarios.conta.split('-')[0] || null,
            conta_digito: this.dados_bancarios.conta.split('-')[1] || null,
            numero_banco: ehOutros
              ? this.outro_codigo
              : this.dados_bancarios.codigo,
            nome_legal: this.dados_bancarios.nome,
            cpf_cnpj: this.dados_bancarios.documento,
          }
          if (this.dados_bancarios.agencia.includes('-')) {
            data['agencia_digito'] =
              this.dados_bancarios.agencia.split('-')[1] || null
          }
          return data
        }
      }
      return {}
    },
    filterAutocomplete(item, queryText, itemText) {
      return (
        removeAccents(itemText)
          .toLocaleLowerCase()
          .indexOf(removeAccents(queryText).toLocaleLowerCase()) > -1
      )
    },
    carregarDadosPessoais() {
      this.loadingDadosPessoais = true

      setTimeout(() => {
        this.dados_pessoais = {
          ...this.dados_pessoais,
          firstname: this.usuarioAtual.nome.split(' ')[0],
          lastname:
            this.usuarioAtual.nome.split(' ').length > 1
              ? this.usuarioAtual.nome.split(' ').reverse()[0]
              : '',
          email: (this.usuarioAtual.email || '').toLowerCase() || '',
          telefone: this.usuarioAtual.telefone || '',
          cpf: this.usuarioAtual.cpf || '',
          data_nascimento: this.usuarioAtual.data_nascimento || '',
        }
        this.loadingDadosPessoais = false
      }, 500)
    },
  },
}
// steps
// Selecionar modelo - Informações basicas - Cobrança - Recebimento - Confirmar
</script>

<template>
  <BaseModal max-width="80%" height="800px" :bus="busModal" persistent>
    <Title
      title="Cadastre um serviço"
      subtitle="Receba dos seus clientes de forma automática"
    />

    <div class="v-application">
      <v-row v-if="loadingCheck" justify="center" align="center">
        <div class="text-center ma-12 w-100">
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-row>
      <v-stepper v-else v-model="step" style="width: 100%" class="elevation-0">
        <v-stepper-header class="elevation-0">
          <v-stepper-step
            :editable="step > 1 && !concluido"
            :complete="step > 1"
            step="1"
          >
            Modelo
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            :editable="step > 2 && !concluido"
            :complete="step > 2"
            step="2"
          >
            Dados básicos
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            :editable="step > 3 && !concluido && !its_free"
            :complete="step > 3"
            step="3"
          >
            Cobrança
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            v-if="!has_wirecard_account"
            :editable="step > 4 && !concluido"
            :complete="step > 4"
            step="4"
          >
            Recebimento
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            :editable="step > (has_wirecard_account ? 4 : 5) && !concluido"
            :complete="step > (has_wirecard_account ? 4 : 5)"
            :step="has_wirecard_account ? 4 : 5"
          >
            Indicação
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            :step="has_wirecard_account ? 5 : 6"
            :editable="step > (has_wirecard_account ? 5 : 6) && !concluido"
            :complete="step > (has_wirecard_account ? 5 : 6)"
          >
            Configurar
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            :editable="step > (has_wirecard_account ? 6 : 7) && !concluido"
            :complete="step > (has_wirecard_account ? 6 : 7)"
            :step="has_wirecard_account ? 6 : 7"
          >
            Confirmação
          </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items class="elevation-0">
          <v-stepper-content step="1" class="pt-0 pb-0">
            <v-simple-table
              v-if="step === 1"
              ref="table-servicos"
              key="tabela-modelos-servicos"
            >
              <template v-slot>
                <thead>
                  <tr>
                    <th class="text-left">Nome</th>
                    <th class="text-left">Descricao</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in modelos"
                    :key="item.title"
                    :style="{ cursor: 'pointer' }"
                    @click="doActions(item.actions)"
                  >
                    <td>{{ item.title }}</td>
                    <td class="text-left">{{ item.subtitle }}</td>
                    <td>
                      <v-btn text icon small>
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-form
              ref="formDadosBasicos"
              v-model="validDadosBasicos"
              @submit.prevent
            >
              <div class="row">
                <v-text-field
                  v-model="servico.nome"
                  class="col-12"
                  label="Nome*"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </div>
              <v-textarea
                v-model="servico.descricao"
                label="Descrição"
              ></v-textarea>
              <v-checkbox
                v-model="aceptTerms"
                required
                :rules="[rules.required]"
              >
                <template v-slot:label>
                  <div>
                    Eu aceito os
                    <v-tooltip bottom disabled>
                      <template v-slot:activator="{ on }">
                        <a
                          target="_blank"
                          href="https://aawz-public.s3.us-east-2.amazonaws.com/politicas/Termos%20de%20Uso.pdf"
                          @click.stop
                          v-on="on"
                        >
                          Termos de Uso.*
                        </a>
                      </template>
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-form>
            <small class="text-secondary">* Campo obrigatório</small>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-form ref="formTaxa" v-model="validTaxa">
              <div class="justify-space-between pl-2">
                <div class="v-application" style="align-items: center">
                  <v-checkbox
                    v-model="taxaBruta"
                    label="Valor fixo"
                    :disabled="its_free"
                  ></v-checkbox>
                  <small class="text-secondary d-inline pl-3">
                    Valor cobrado invariavelmente.
                  </small>
                  <v-tooltip bottom style="margin-left: 10px">
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on">mdi-alert-circle-outline</v-icon>
                    </template>
                    <span>
                      Nos serviços recorrentes, as cobranças iniciam no mês
                      seguinte a contratação.
                    </span>
                  </v-tooltip>
                </div>
                <div v-if="taxaBruta">
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="servico.taxaBruta"
                        v-money="maskMoney"
                        :rules="[rules.taxMinReal]"
                        label="Valor*"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="servico.metodoBruto"
                        style="margin-top: 10px"
                        :items="['À vista', 'Parcelado', 'Recorrente']"
                        label="Forma de pagamento"
                        :rules="[rules.metodoBruto]"
                      ></v-select>
                    </v-col>
                    <v-col v-if="servico.metodoBruto === 'Parcelado'">
                      <!-- <v-text-field
                        v-model="servico.qtdParcelas"
                        v-mask="maskNumberShort"
                        :rules="[rules.max12, rules.min1]"
                        label="Parcelas"
                        :messages="`Cada parcela no valor de: ${valorParcelas}`"
                      >
                      </v-text-field> -->
                      <v-select
                        v-model="servico.qtdParcelas"
                        :items="opcoesParcelas"
                        label="Parcelas"
                      >
                      </v-select>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <div class="justify-space-between pl-2">
                <div class="v-application" style="align-items: center">
                  <v-checkbox
                    v-model="taxaPatrimonio"
                    :disabled="its_free"
                    label="Taxa sobre o patrimônio"
                    style="width: fit-content"
                    class="d-inline"
                    @change="statusNextButton"
                  >
                  </v-checkbox>
                  <small class="text-secondary d-inline pl-3">
                    Taxa anual cobrada mensalmente (semelhante à taxa de
                    administração de fundos).
                  </small>
                </div>
                <v-row v-if="taxaPatrimonio">
                  <v-text-field
                    v-model="servico.taxaPatrimonio"
                    v-money="maskPercent"
                    :rules="[rules.taxMinPerc]"
                    label="Taxa*"
                    class="col-2"
                  >
                  </v-text-field>
                  <v-text-field
                    v-model="servico.valorMinimo"
                    v-money="maskMoney"
                    class="col-2"
                    label="Valor mínimo*"
                    :rules="[rules.taxMinReal]"
                  >
                  </v-text-field>
                  <!-- <v-autocomplete
                    :items="[
                      'aaaaaaaaaaaaaaaa',
                      'bbbbbbbbbbbbbbbbbbbb',
                      'cccccccccccccccccccc',
                      'dddddddddddddddddd',
                      'eeeeeeeeeeeeeeee',
                      'ffffffffffffffffffffffff',
                      'gggggggggggggggggggggggg',
                    ]"
                    v-model="servico.blackListInstituicoes"
                    dense
                    chips
                    small-chips
                    multiple
                    clearable
                    deletable-chips
                    label="Instituições não cobradas"
                    class="col-8"
                    messages="Caso não queira realizar a cobrança do patrimônio investido do seu cliente em alguma instituição específica, insira acima. Se você não marcar nenhuma opção, a taxa sobre o patrimônio será cobrada de forma global."
                  >
                    <template v-slot:label>
                      Instituições <strong>não</strong> cobradas
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>
                          Disponibilizamos essa parametrização para que você não
                          remunere de forma
                          <br />
                          duplicada seus clientes que são atendidos por você em
                          alguma corretora.
                          <br />
                          Você pode cadastrar serviços específicos para esses
                          clientes e gerar a cobrança
                          <br />
                          apenas em cima do patrimônio investido em outras
                          casas.
                        </span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete> -->
                </v-row>
              </div>
              <small class="text-secondary mt-3">* Campos obrigatórios</small>
            </v-form>
          </v-stepper-content>

          <!-- <v-stepper-content step="4">
            <p>
              Caso <strong>não</strong> queira realizar a cobrança do patrimônio
              investido do seu cliente em alguma instituição específica, insira
              abaixo. Se você não marcar nenhuma opção, a taxa sobre o
              patrimônio será cobrada de forma global (
              <BaseLink>saiba mais</BaseLink> ).
            </p>
            mais procuradas: XP Genial
            <br />
            selecione outra instituição (dataframe bancos + corretoras - lista
            corretoras
            http://www.b3.com.br/pt_br/produtos-e-servicos/participantes/busca-de-participantes/busca-de-corretoras/)
            <small>
              Saiba mais: Disponibilizamos essa parametrização para que você não
              remunere de forma duplicada seus clientes que são atendidos por
              você em alguma corretora. Você pode cadastrar serviços específicos
              para esses clientes e gerar a cobrança apenas em cima do
              patrimônio investido em outras casas.
            </small>
          </v-stepper-content> -->

          <v-stepper-content v-if="!has_wirecard_account" step="4">
            <div v-if="cadastrarConta">
              <v-checkbox
                v-model="pj"
                label="Pessoa jurídica"
                class="pl-2 mt-0 pt-2"
                dense
              ></v-checkbox>
              <h1 class="subhead">
                {{ pj ? 'Dados do representante' : 'Dados pessoais' }}
                <v-btn
                  small
                  class="ml-2"
                  :loading="loadingDadosPessoais"
                  @click="carregarDadosPessoais"
                >
                  Carregar dados pessoais
                </v-btn>
              </h1>
              <CardDiv>
                <v-form
                  ref="formDadosPessoais"
                  v-model="validDadosPessoais"
                  :lazy-validation="true"
                >
                  <v-row>
                    <v-text-field
                      v-model="dados_pessoais.firstname"
                      label="Primeiro nome*"
                      class="col-6"
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.lastname"
                      :rules="[rules.required]"
                      required
                      label="Último nome*"
                      class="col-6"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.email"
                      :rules="[rules.required, rules.email]"
                      required
                      label="E-mail*"
                      class="col-6"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.telefone"
                      v-mask="maskPhone"
                      :rules="[rules.required, rules.phone]"
                      required
                      label="Telefone*"
                      class="col-3"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.cpf"
                      v-mask="maskCPF"
                      :rules="[rules.required, rules.cpf]"
                      required
                      label="CPF*"
                      class="col-3"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.data_nascimento"
                      v-mask="maskData"
                      label="Data de nascimento*"
                      class="col-4"
                      :rules="[rules.required, rules.data]"
                    ></v-text-field>
                  </v-row>
                  <v-divider />
                  <v-row>
                    <v-text-field
                      v-model="dados_pessoais.cep"
                      v-mask="maskCEP"
                      label="CEP*"
                      class="col-3"
                      :rules="[rules.required, rules.cep]"
                      required
                      @change="getCepDadosPessoais"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.rua"
                      label="Rua"
                      class="col-6"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.numero"
                      v-mask="maskNumber"
                      label="Número*"
                      class="col-3"
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.complemento"
                      label="Complemento"
                      class="col-3"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.bairro"
                      label="Bairro"
                      class="col-3"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.cidade"
                      label="Cidade"
                      class="col-3"
                      disabled
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_pessoais.estado"
                      label="Estado"
                      class="col-3"
                      disabled
                    ></v-text-field>
                  </v-row>
                </v-form>
              </CardDiv>
              <h1 v-if="pj" class="subhead mt-10">Dados da empresa</h1>
              <v-form
                ref="formDadosEmpresariais"
                v-model="validDadosEmpresariais"
                lazy-validation
              >
                <CardDiv v-if="pj">
                  <template>
                    <v-row>
                      <v-text-field
                        v-model="dados_empresariais.nome_fantasia"
                        label="Nome fantasia*"
                        class="col-6"
                        :rules="[rules.required]"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.razao_social"
                        label="Razão social*"
                        class="col-6"
                        :rules="[rules.required]"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.telefone"
                        v-mask="maskPhone"
                        :rules="[rules.required, rules.phone]"
                        required
                        label="Telefone*"
                        class="col-6"
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.cnpj"
                        v-mask="maskCNPJ"
                        :rules="[rules.required, rules.cnpj]"
                        required
                        label="CNPJ*"
                        class="col-6"
                      ></v-text-field>
                    </v-row>
                    <v-divider />
                    <v-row>
                      <v-text-field
                        v-model="dados_empresariais.cep"
                        v-mask="maskCEP"
                        :rules="[rules.required, rules.cep]"
                        required
                        label="CEP*"
                        class="col-3"
                        @change="getCepDadosEmpresariais"
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.rua"
                        label="Rua"
                        class="col-6"
                        disabled
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.numero"
                        v-mask="maskNumber"
                        label="Número*"
                        class="col-3"
                        :rules="[rules.required]"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.complemento"
                        label="Complemento"
                        class="col-3"
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.bairro"
                        label="Bairro"
                        class="col-3"
                        disabled
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.cidade"
                        label="Cidade"
                        class="col-3"
                        disabled
                      ></v-text-field>
                      <v-text-field
                        v-model="dados_empresariais.estado"
                        label="Estado"
                        class="col-3"
                        disabled
                      ></v-text-field>
                    </v-row>
                  </template>
                </CardDiv>
              </v-form>
              <h1 class="subhead mt-10">Dados bancários</h1>
              <CardDiv>
                <v-form
                  ref="formDadosBancarios"
                  v-model="validDadosBancarios"
                  lazy-validation
                >
                  <v-row>
                    <v-text-field
                      v-model="dados_bancarios.nome"
                      label="Nome do titular*"
                      class="col-7"
                      :rules="[rules.required]"
                    />
                    <v-text-field
                      v-model="dados_bancarios.documento"
                      v-mask="[maskCPF, maskCNPJ]"
                      label="Documento do titular (CPF ou CNPJ)*"
                      class="col-5"
                      :rules="[rules.required, rules.cpf_cnpj]"
                    />
                    <v-autocomplete
                      v-model="dados_bancarios.codigo"
                      label="Banco*"
                      class="col-7"
                      :items="bancos"
                      :item-text="
                        (item) => {
                          return `${item.codigo} - ${item.nome}`
                        }
                      "
                      item-value="codigo"
                      clearable
                      :filter="filterAutocomplete"
                      :rules="[rules.required]"
                    >
                    </v-autocomplete>
                    <v-text-field
                      v-model="dados_bancarios.agencia"
                      v-mask="['####', '####-#', '####-##']"
                      label="Agência*"
                      class="col-2"
                      :rules="[rules.required]"
                    ></v-text-field>
                    <v-text-field
                      v-model="dados_bancarios.conta"
                      v-mask="[
                        '###-#',
                        '####-#',
                        '#####-#',
                        '######-#',
                        '#######-#',
                        '########-#',
                        '#########-#',
                      ]"
                      label="Conta*"
                      class="col-3"
                      :rules="[rules.required]"
                    />
                    <v-text-field
                      v-if="dados_bancarios.codigo === -1"
                      v-model="outro_nome"
                      class="col-7"
                      label="Nome do banco*"
                      :rules="[rules.required]"
                    />
                    <v-text-field
                      v-if="dados_bancarios.codigo === -1"
                      v-model.number="outro_codigo"
                      class="col-5"
                      label="Código do banco*"
                      :rules="[rules.required]"
                    />
                  </v-row>
                </v-form>
              </CardDiv>
              <small class="text-secondary mt-5">* Campos obrigatórios</small>
            </div>
            <div
              v-else
              class="row justify-center font-weight-bold"
              style="padding: 15px"
            >
              <p>{{ this.messageReceivingAccount }}</p>
            </div>
          </v-stepper-content>

          <v-stepper-content :step="has_wirecard_account ? 4 : 5">
            <div class="v-application" style="align-items: center">
              <v-checkbox
                v-model="indicar_servico"
                label="Indicar serviço"
              ></v-checkbox>
              <small class="text-secondary d-inline pl-3">
                Seu serviço ficará disponível para indicação.
              </small>
              <v-tooltip bottom style="margin-left: 10px">
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">mdi-alert-circle-outline</v-icon>
                </template>
                <span style="text-align: justify">
                  Você deseja remunerar quem indicar esse serviço para você?
                  <br />
                  Insira uma porcentagem e deixe disponibilizado o serviço.
                  <br />
                  Seus profissionais autorizados irão enviar o link desse
                  serviço para clientes e, assim que esses
                  <br />
                  clientes contratarem pelo link enviado nós cuidamos dos
                  repasses de acordo com a % que você inserir.
                </span>
              </v-tooltip>
            </div>
            <div v-if="indicar_servico">
              <v-text-field
                v-model="pct_repasse"
                v-money="maskPercent"
                :rules="[rules.taxMinPerc]"
                label="Porcentagem de repasse*"
              >
              </v-text-field>
            </div>
          </v-stepper-content>

          <v-stepper-content
            :step="has_wirecard_account ? 5 : 6"
            style="height: 330px"
          >
            <v-row>
              <v-col cols="6">
                <CardDiv secondary>
                  <div
                    v-if="!urlImagem"
                    class="justify-content-center align-items-center text-center d-flex"
                    style="height: 90%"
                  >
                    <p class="text-secondary"> Nenhuma imagem selecionada </p>
                  </div>
                  <v-img
                    :src="urlImagem"
                    aspect-ratio="1"
                    contain
                    height="250"
                    class="p-0 border"
                  >
                  </v-img>
                </CardDiv>
              </v-col>
              <v-col cols="6" class="justify-content-center align-items-center">
                <v-form ref="formConfig">
                  <div class="d-flex flex-inline" style="align-items: center">
                    <v-col cols="12" md="11" style="padding: 0px">
                      <v-file-input
                        ref="servicoImagem"
                        v-model="fileImagem"
                        prepend-icon="image"
                        accept="image/*"
                        label="Imagem de corpo de e-mail"
                        show-size
                        :rules="[rules.maxSize]"
                        @change="changeUploadImage"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="12" md="1" style="margin-left: 2px">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        <span>
                          Utilize essa imagem para enviar alguma informação ou
                          arte atrelada ao seu serviço.
                          {{
                            this.isWhitelabel
                              ? 'Sua logo e cores é enviada dentro do modelo de e-mail.'
                              : ''
                          }}
                        </span>
                      </v-tooltip>
                    </v-col>
                  </div>
                  <v-file-input
                    v-model="fileAnexo"
                    label="Arquivo de anexo"
                    show-size
                    :rules="[rules.maxSize]"
                  ></v-file-input>
                  <div class="d-flex flex-inline" style="align-items: center">
                    <v-col cols="12" md="11" style="padding: 0px">
                      <v-checkbox
                        v-model="servico.visivel"
                        hide-details
                        dense
                        label="Tornar serviço visível para qualquer cliente"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                      style="margin-left: 2px; padding-bottom: 0px"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        <span>
                          {{
                            this.isWhitelabel
                              ? 'Ao marcar essa opção, qualquer cliente que acessar seu aplicativo poderá ver esse serviço e realizar contratação a qualquer momento.'
                              : ''
                          }}
                          Deixe desmarcado se deseja que as contratações sejam
                          realizadas apenas quando você enviar um link/e-mail
                          para seus clientes.
                        </span>
                      </v-tooltip>
                    </v-col>
                  </div>
                  <v-col cols="12" md="12" style="padding: 0px">
                    <v-checkbox
                      v-model="servico.visivel_para_profissionais"
                      hide-details
                      dense
                      label="Tornar serviço visível para qualquer profissional"
                    />
                  </v-col>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content :step="has_wirecard_account ? 6 : 7">
            <p> Parabéns! Serviço cadastrado com sucesso! </p>
            <p v-if="!its_free && !has_wirecard_account">
              Você receberá um e-mail da AAWZ e de nossa parceira de pagamentos
              explicando como gerenciar seus recebimentos.
            </p>
            <p>
              Para ver seu serviço cadastrado, clique
              <!-- <router-link :to="{ name: 'servicos' }">aqui</router-link>. -->
              <a href="#" @click="toServices">aqui</a>
            </p>
            <p>
              Para enviar um link de adesão dos serviços para seus clientes,
              clique
              <!-- <router-link :to="{ name: 'servicos' }">aqui</router-link>. -->
              <a href="#" @click="toServices">aqui</a>
              <!-- 'adesao' -->
            </p>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <template v-if="Number(step) !== 1">
        <!-- <BaseButton underlined @click="close">
          Cancelar
        </BaseButton> -->
        <BaseButton v-if="step < 6" underlined @click="backStep">
          Voltar
        </BaseButton>
        <!-- && !(has_wirecard_account && step == 3) -->
        <BaseButton
          v-if="
            isWhitelabel && cancelProcess
              ? step < 5
              : step < (has_wirecard_account ? 5 : 6)
          "
          primary
          @click="nextStep"
        >
          Próximo
        </BaseButton>
        <BaseButton
          v-if="isWhitelabel && cancelProcess && step === 4"
          primary
          @click="close"
        >
          Sair
        </BaseButton>
        <!-- (!has_wirecard_account && step == 4) ||
            (its_free && step == 2) ||
              (has_wirecard_account && step == 3) -->
        <BaseButton
          v-if="step === (has_wirecard_account ? 5 : 6)"
          primary
          :loading="loading"
          @click="salvar(close)"
        >
          Salvar
        </BaseButton>
        <!-- <BaseButton
          v-if="step === (has_wirecard_account ? 4 : 5)"
          dark
          @click="close"
        >
          Fechar
        </BaseButton> -->
        <BaseButton
          v-if="step === (has_wirecard_account ? 6 : 7) && $canSendLinks"
          primary
          @click="openSendLink(close)"
        >
          Enviar link
        </BaseButton>
      </template>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<style lang="sass" module>
.active
  background-color: var(--primary) !important
  color: white !important
</style>
